import React from 'react'
import { Route } from 'react-router-dom'
import { element } from 'prop-types'
import { useAuth } from 'shared/application/hooks/useAuthProvider.hook'
import { useAuthVerify } from 'shared/application/hooks/useAuthVerify'
import { Routes } from 'config/routes'

function PrivateRoute({ children, ...rest }) {
  useAuthVerify()
  const auth = useAuth()

  return (
    <Route
      {...rest}
      render={() =>
        auth.isAuthenticated() ? children : window.location.assign(Routes.Login)
      }
    />
  )
}

PrivateRoute.propTypes = {
  children: element,
}

export { PrivateRoute }
